import {ViewProps} from './model';
import {View} from 'react-native';
import React from 'react';
import {NotificationResponsePayload} from '../../../../shared/models/api';
import {images} from '../../../../assets/icons';
import {dateFormats} from '../../../../shared/constants/date';
import {datePipe} from '../../../../shared/pipes';
import {useNavigation} from '@react-navigation/native';
import {Link} from '../../../../shared/components/link';
import {Screens} from '../../../../shared/routing';
import {Table} from '../../../../shared/components/table';
import {Column} from '../../../../shared/components/table/model';
import {Text} from '../../../../shared/components/text';
import {NotificationStatus} from '../../../../shared/models/profile/notification';
import {GetDesktopStyles} from './style';

export default ({notifications}: ViewProps) => {
  const nav = useNavigation();
  const styles = GetDesktopStyles();

  const columns: Column<NotificationResponsePayload>[] = [
    {
      title: '',
      render: (notification) => {
        const isRead = notification.statusId === NotificationStatus.Read;
        return (
          <View style={styles.icon}>
            {isRead ? (
              <images.NotCheckRound width={styles.icon.width} height={styles.icon.height} color={styles.icon.color} />
            ) : (
              <images.CheckRound width={styles.icon.width} height={styles.icon.height} color={styles.icon.color} />
            )}
          </View>
        );
      },
      field: 'statusId',
      headStyles: {
        colHeadStyle: styles.colStatus,
      },
      styles: {
        colBodyStyle: styles.colStatus,
      },
    },
    {
      title: 'Тема',
      render: (notification) => {
        const isRead = notification.statusId === NotificationStatus.Read;
        return (
          <Link
            testID='notification-list-item-link-id-desktop'
            textStyle={isRead ? styles.colBodyMessageText : styles.colBodyMessageTextNotRead}
            navigate={nav.navigate}
            screenParams={{id: notification.id || ''}}
            screen={Screens.Notifications}>
            {notification.topic}
          </Link>
        );
      },
      field: 'topic',
      headStyles: {
        colHeadStyle: styles.colText,
      },
      styles: {
        colBodyStyle: styles.colText,
      },
    },
    {
      title: 'Дата',
      render: (notification) => {
        const isRead = notification.statusId === NotificationStatus.Read;
        return (
          <Text style={isRead ? styles.colBodyText : styles.colBodyTextNotRead}>{datePipe(notification.dateTime)}</Text>
        );
      },
      field: 'dateTime',
      headStyles: {
        colHeadStyle: styles.colDate,
      },
      styles: {
        colBodyStyle: styles.colDate,
      },
    },
    {
      title: 'Время',
      render: (notification) => {
        const isRead = notification.statusId === NotificationStatus.Read;
        return (
          <Text style={isRead ? styles.colBodyText : styles.colBodyTextNotRead}>
            {datePipe(notification.dateTime, dateFormats.time)}
          </Text>
        );
      },
      field: 'dateTime',
      headStyles: {
        colHeadStyle: styles.colTime,
      },
      styles: {
        colBodyStyle: styles.colTime,
      },
    },
  ];
  return (
    <View>
      <Table data={notifications} columns={columns} testIdPrefix='notification-row' />
    </View>
  );
};
